import {kmsQueries} from '@domain/kiln-monitoring'
import {Loader} from '@hconnect/uikit/src/lib2'
import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import {Outlet, Navigate} from 'react-router'

import {useTrackMaintainEvent} from '../../../shared/hooks/useTrackMaintain'
import {usePlantUpmId} from '../../shared/hooks/usePlantUpmId'
import {Crank} from '../components/Crank/Crank'
import {KMS, KmsContainer} from '../components/KMS'

export const KmsMain = () => {
  const trackMaintainEvent = useTrackMaintainEvent()

  useEffect(() => {
    trackMaintainEvent({name: 'kmsUserLoggedIn'})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Outlet />
}

const NavigateToFirstKiln = () => {
  const upmId = usePlantUpmId()
  const {isLoading, data} = useQuery(kmsQueries.kilnInfo(upmId))

  if (isLoading) return <Loader color="grey" height="60vh" />

  // We cannot proceeed without this data so better crash the app early
  if (!data?.[0].id) throw new Error('No kilns defined in asset config.')

  return <Navigate to={data[0].id} replace />
}

export const KmsRoutes = [
  {
    index: true,
    element: <NavigateToFirstKiln />
  },
  {
    path: ':kilnId',
    element: <KmsContainer />,
    children: [
      {
        index: true,
        element: <KMS />
      },
      {
        path: 'crank',
        element: <Crank />
      },
      {
        path: '*',
        element: <Navigate to=".." replace />
      }
    ]
  }
]
